<template>
  <ckeditor :editor="editor" v-model="data_content" :config="editorConfig"></ckeditor>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import {mapGetters} from "vuex";
export default {
  name: "CKEditor",
  props: {
    content: {
      default: () => ''
    },
  },
  data() {
    return {
      data_content: this.content,
      editor: Editor,
      editorConfig: {
        removePlugins: ["Markdown","MediaEmbedToolbar"],
        ckfinder: {
          uploadUrl: '',
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      'getEndpoint': 'settings/getEndpoint',
      'getUser':'user/getUser'
    }),
  },
  async created(){
    this.editorConfig.ckfinder = {
      uploadUrl: `${this.getEndpoint}api/v1/multimedia/ckeditor?token=${this.getUser.token}`,
    }
  },
  watch: {
    data_content (newValue) {
      this.data_content = newValue
      this.$emit('message',this.data_content)
    }
  }
}
</script>

<style scoped>

</style>